import React from 'react';
import { connect } from 'react-redux';

import Tabla from '../../commons/Tabla';
import Bloque from '../../commons/Bloque';
import CheckBox from '../../commons/CheckBox';

import {
  getSucursalesAction,
  getSeleccionarSucursalAction,
  getSeleccionarPromocionSucursalAction,
  actualizarFiltros,
} from '../../redux/actions/sucursal.action';

import EditIcon from '@material-ui/icons/Edit';
import PhotoAlbumIcon from '@material-ui/icons/PhotoAlbum';

const SucursalList = ({
  sucursales,
  processing,
  total,
  getSucursalesAction,
  getSeleccionarSucursalAction,
  getSeleccionarPromocionSucursalAction,
  actualizarFiltros,
}) => {
  const columns = [
    {
      key: 'su',
      align: 'center',
      content: (item) => (
        <>
          <div title="Editar" style={{ display: 'inline-block' }}>
            <EditIcon
              onClick={() => getSeleccionarSucursalAction(item)}
              style={{ color: 'green', cursor: 'pointer' }}
            />
          </div>
          <div title="Promociones" style={{ display: 'inline-block' }}>
            <PhotoAlbumIcon
              onClick={() => getSeleccionarPromocionSucursalAction(item)}
              style={{ color: '#3285a8', cursor: 'pointer' }}
            />
          </div>
        </>
      ),
    },
    {
      key: 'ns',
      label: 'Nombre',
    },
    {
      key: 'sp',
      align: 'center',
      label: 'Principal',
      content: (item) => (item.sp === 'S' ? 'SI' : 'NO'),
    },
    {
      key: 'de',
      label: 'Estado sucursal',
    },
    {
      key: 'st',
      label: 'Estado de registro',
      align: 'center',
      content: (item) => <CheckBox checked={item.st} disabled />,
    },
  ];

  return (
    <Bloque titulo="Resultado de b&uacute;squeda">
      <Tabla
        columns={columns}
        data={sucursales}
        processing={processing}
        total={total}
        onPagination={({ page, rows }) =>
          getSucursalesAction({ page, pageSize: rows })
        }
        onSearching={() => getSucursalesAction({})}
        onChangeSearching={(search) => actualizarFiltros({ search })}
      />
    </Bloque>
  );
};

const mapStateToProps = (state) => {
  return {
    sucursales: state.sucursal.sucursales,
    processing: state.sucursal.processing,
    total: state.sucursal.total,
  };
};

export default connect(mapStateToProps, {
  getSucursalesAction,
  getSeleccionarSucursalAction,
  getSeleccionarPromocionSucursalAction,
  actualizarFiltros,
})(SucursalList);
